import { useState, useEffect } from "react";
import PasswordChangeModal from "../Modal/PasswordChangeModal";
import { useRecoilState, useRecoilValue } from "recoil";
import { userInfoAtom } from "../../recoil/user";
import styled from "styled-components";
import media from "../../static/style/media";
import { useForm } from "react-hook-form";
import { accessTokenAtom } from "../../recoil/auth";
import SaveAlert from "../Alert/SaveAlert";
import { getUser } from "../../apis/api/User/getUser";
import { patchUser } from "../../apis/api/User/patchUser";
import { useTranslation } from "react-i18next";
import { useTimeFormat } from "../../library/useTimeFormat";

function ProfileForm() {
  const accessToken = useRecoilValue(accessTokenAtom);
  const [passwordChangeModalIsOpen, setPasswordChangeModalIsOpen] =
    useState(false);
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const { date } = useTimeFormat();
  const { register, handleSubmit, setValue } = useForm({
    defaultValues: {
      email: userInfo?.email,
      teamName: userInfo?.teamName,
      nickname: userInfo?.nickname,
      phone: userInfo?.phone,
      role: userInfo?.role,
      createdAt: date(userInfo?.createdAt),
      updatedAt: date(userInfo?.updatedAt),
    },
  });

  useEffect(() => {
    setValue("email", userInfo?.email);
    setValue("teamName", userInfo?.teamName);
    setValue("nickname", userInfo?.nickname);
    setValue("phone", userInfo?.phone);
    setValue("role", userInfo?.role);
    setValue("createdAt", date(userInfo?.createdAt));
    setValue("updatedAt", date(userInfo?.updatedAt));
  }, [userInfo]);

  const openPasswordChangeModal = () => {
    setPasswordChangeModalIsOpen(true);
  };

  const onSubmit = async (data) => {
    try {
      await patchUser(data, accessToken);
      const userRes = await getUser(accessToken);
      setUserInfo(userRes);
      SaveAlert();
    } catch (e) {
      alert(e);
    }
  };

  const { t } = useTranslation();

  return (
    <ContentContainer>
      <ListTitle>{t(`information`)}</ListTitle>
      <BasicForm onSubmit={handleSubmit(onSubmit)}>
        <FormContainer>
          <FormLabel>{t(`email`)}</FormLabel>
          <FormInput {...register("email")} disabled />
        </FormContainer>
        <FormContainer>
          <FormLabel>{t(`team name`)}</FormLabel>
          <FormInput {...register("teamName")} disabled />
        </FormContainer>
        <FormContainer>
          <FormLabel>{t(`name`)}</FormLabel>
          <FormInput {...register("nickname")} />
        </FormContainer>
        <FormContainer>
          <FormLabel>{t(`phone`)}</FormLabel>
          <FormInput {...register("phone")} />
        </FormContainer>
        <FormContainer>
          <FormLabel>{t(`authority`)}</FormLabel>
          <FormInput {...register("role")} disabled />
        </FormContainer>
        <SaveBtnContainer>
          <SaveBtn type="submit">{t(`save`)}</SaveBtn>
        </SaveBtnContainer>
      </BasicForm>

      <ListTitle>{t(`change password`)}</ListTitle>
      <PasswordChangeBtnContainer>
        <PasswordChangeBtn onClick={openPasswordChangeModal}>
          {t(`change`)}
        </PasswordChangeBtn>
      </PasswordChangeBtnContainer>

      <ListTitle>{t(`etc`)}</ListTitle>
      <FormContainer>
        <FormLabel>{t(`creation date`)}</FormLabel>
        <FormInput {...register("createdAt")} disabled />
      </FormContainer>
      <FormContainer>
        <FormLabel>{t(`access date`)}</FormLabel>
        <FormInput {...register("updatedAt")} disabled />
      </FormContainer>
      <PasswordChangeModal
        isOpen={passwordChangeModalIsOpen}
        isClose={setPasswordChangeModalIsOpen}
      />
    </ContentContainer>
  );
}

export const ContentContainer = styled.div`
  padding: 30px;
  width: 100%;
  max-width: 800px;
  background-color: #f9f9f9;
  margin: 20px auto 0;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  ${media.small`
    width: 100%;
  `}
`;

export const ListTitle = styled.div`
  font-weight: bold;
  font-size: 1.8rem;
  color: #175eb4;
  border-bottom: 2px solid #ddd;
  padding-bottom: 10px;
  margin-bottom: 25px;
`;

export const FormLabel = styled.label`
  font-weight: 500;
  color: #666;
  margin-bottom: 5px;
  line-height: 2rem;
`;

export const FormInput = styled.input`
  height: 40px;
  width: 100%;
  padding: 8px 15px;
  font-size: 1.1rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-sizing: border-box;
  &:focus {
    border-color: #175eb4;
    outline: none;
    box-shadow: 0 0 5px rgba(23, 94, 180, 0.1);
  }
`;

export const BasicForm = styled.form`
  margin-bottom: 30px;
`;

export const FormContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 4fr;
  gap: 10px;
  padding: 15px 0;
  border-bottom: 1px solid #eee;
`;

export const SaveBtnContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const SaveBtn = styled.button`
  margin-top: 20px;
  padding: 12px 25px;
  background-color: #175eb4;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: bold;
  font-size: 1.1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #004b8d;
  }
`;

export const PasswordChangeBtnContainer = styled(SaveBtnContainer)``;
export const PasswordChangeBtn = styled(SaveBtn)`
  background-color: #f04e31;
  &:hover {
    background-color: #d43d22;
  }
`;

export default ProfileForm;
